<template>
  <!-- Upload content -->
  <v-row align="start" justify="start">
    <v-col cols="12">
      <v-row>
        <v-col cols="8">
          <v-btn class="mr-2" to="/admin/projects/add" v-if="listView"
            >Add</v-btn
          >
          <v-btn class="mr-2" to="/admin/projects" v-else>Close</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col :cols="containerWidth" v-if="!resultView">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Title</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sortedList" :key="item.id">
              <td>{{ item.title }}</td>
              <td>
                <v-chip class="mr-2" :to="`/admin/projects/show/${item.id}`">
                  Show
                </v-chip>
                <v-chip class="mr-2" :to="`/admin/projects/edit/${item.id}`">
                  Edit
                </v-chip>
                <v-chip class="mr-2" :to="`/admin/projects/results/${item.id}`">
                  Results
                </v-chip>
                <!-- <v-chip class="mr-2" @click="deleteItem(item.id)">
                      Delete
                    </v-chip> -->
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-col :cols="childWidth" v-if="!listView">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import router from "@/router";
import lodash from "lodash";

export default {
  name: "AdminProjectList",
  data() {
    return {
      collection: fb.projectsCollection,
      items: null,
      returnRoute: "AdminProjectList",
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    listView() {
      return this.$route.name == "AdminProjectList" ? true : false;
    },
    resultView() {
      return this.$route.name == "AdminProjectResults" ? true : false;
    },
    containerWidth() {
      return this.listView ? "12" : "4";
    },
    childWidth() {
      return this.resultView ? "12" : "8";
    },
    cardWidth() {
      return this.listView ? "3" : "12";
    },
    sortedList() {
      return this.items ? lodash.orderBy(this.items, "title", "asc") : [];
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.collection.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((doc) => {
          let post = doc.data();
          items.push(post);
        });
        this.items = items;
      });
    },
    deleteItem(id) {
      this.collection
        .doc(id)
        .delete()
        .then(() => {
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
  },
};
</script>
